import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a6c6702"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "最懂安全的AI智能体", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "轻松注册，免费体验", -1));
const _hoisted_3 = {
  class: "buttom-box"
};
import { ref } from 'vue';
import ButtomCom from '@/components/buttomCom.vue';
export default {
  __name: 'applyCom',
  setup(__props, {
    expose: __expose
  }) {
    let pageActive = ref(false);
    const jumpPage = url => {
      // 获取当前页面地址
      url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      window.open(url);
    };
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'apply-dom active' : 'apply-dom')
      }, [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(ButtomCom, {
        effect: 'dark',
        isArrow: true,
        btnName: "免费试用",
        onClick: _cache[0] || (_cache[0] = $event => jumpPage('/bookDemoPage.html'))
      })])], 2);
    };
  }
};